<template>
  <div class="row mb-4">
      <div class="col col-12 col-md-4 col-lg-6 colorsample-cartitem-color">
        <div class="color-block" :style="{ background : (color.hex && color.hex.length>0) ? (color.hex.substring(0,1) != '#' ? '#' : '')+color.hex : 'url('+color.image+')' }"></div>
      </div>
      <div class="col col-6 col-md-3 col-lg-2 colorsample-cartitem-details">
        <div class="color-code-buttons-container">
          <a href="#" class="actionToggleDashboard color-code-button">
            <i :data-card-id="color.card.id"
               data-add-url="/myBaumit/ajaxAddCardToDashboard"
               data-delete-url="/myBaumit/ajaxDeleteCardFromDashboard"
               data-added-to-dashboard="0" class="actionToggleDashboard
               material-icons ">star_border</i>
          </a>
          <a href="#" class="color-code-button" @click="remove">
            <delete-s-v-g class="svg-icon"></delete-s-v-g>
          </a>
        </div>
        <span class="color-code-title">{{ trans('products_color_code') }}</span>
        <br/>
        <span class="color-code">{{ color.name }}</span>
        <p class="color-details">
          <span v-if="color.hex">HEX: {{ color.hex  }}</span><br/>
          <span v-if="color.rgb_r">RGB: {{ color.rgb_r + '/' + color.rgb_g  + '/' + color.rgb_b }}</span><br/>
          <!-- <template v-if="color.tsr && color.tsr > 25">
            <span>TSR: > 25</span><br/>
          </template>
          <template v-if="color.tsr && color.tsr <= 25">
            <span>TSR: ≤ 25</span><br/>
          </template>  -->
          <span v-if="color.hbw">HBW: {{ color.hbw  }}</span><br/>
        </p>
      </div>
      <div class="col col-6 col-md-5 col-lg-4 colorsample-cartitem-functions">
        <div class="color-order">
          <div class="color-order-row">
            <span class="mr-2 color-order-row-label">{{ trans('sample_order_unit_price') }}: </span>
            <span class="color-order-row-value">{{ currency  + ' ' + myPpriceFormat(getUnitPriceWithVat) }}</span>
          </div>
          <div class="color-order-row color-order-row-last-row" v-if="false">
            <span class="color-order-subtotal mr-2 color-order-row-label">{{ trans('sample_order_subtotal') }}: </span>
            <span class="color-order-row-value">{{ currency + ' ' + myPpriceFormat(getSubtotal) }}</span>
          </div>
          <div class="color-order-row">
            <span class="mr-2 color-order-row-label"><strong>{{ trans('sample_order_quantity') }}</strong>: </span>
            <div class="color-order-button-wrapper">
              <span :class="canModifyQuantity ? 'mr-2' : ''">{{ quantity }}</span>
              <template v-if="canModifyQuantity">
                <i :class="getButtonClass('fa-plus')" aria-hidden="true" @click="increase"></i>
                <span v-if="false">/</span>
                <i :class="getButtonClass('fa-minus')" aria-hidden="true" @click="decrease"></i>
              </template>
            </div>
          </div>
          <div class="color-order-row" v-if="enableStructure">
            <div class="color-order-structure-container" :style="{ background : (color.hex && color.hex.length>0) ? (color.hex.substring(0,1) != '#' ? '#' : '')+color.hex : 'url('+color.image+')'}">
              <div class="color-order-structure-image-border">
                <div class="color-order-structure-image" :style="{ backgroundImage : 'url(' + selectedStructureObject.image  +')'  }"></div>
              </div>
              <span class="color-order-structure-select-label">{{ trans('sample_order_texture_code') }}</span>
              <div class="color-order-structure-select">
                <button class="btn btn-secondary dropdown-toggle-dropdown-order"
                        type="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false">
                  {{ this.structure }}
                </button>
                <div class="dropdown-menu">
                  <template>
                    <button class="dropdown-item" type="button"
                            v-for="(item, key) in structures" :key="key"
                            @click="changeStructure(item)">
                            {{ item.name }}
                    </button>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="color-order-row">
            <p class="color-order-structure-details" v-if="enableStructure">
              {{ selectedStructureObject.cart_info_text }}
            </p>
            <p class="color-order-structure-details" v-else v-html="trans('sample_order_default_structure_info')">
              
            </p>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  import axios from 'axios';
  import {translate} from "../service/translation";
  import {priceFormat} from "../service/format";
  import DeleteSVG from "@/components/deleteSVG";
  export default {
    components: {DeleteSVG},
    data : function() {
      return {
        changingData : false,
        structure : null,
        selectedStructureObject: {
          car_info_text:'',
          image:'',
          name:'',
        }
      }
    },
    props : {
      color : {
        required : true,
        type : Object
      },
      unitPrice : {
        required : true,
        type : Number
      },
      quantity : {
        required : true,
        type : Number
      },
      setStructure : {
        required : true,
        type : String
      },
      structures : {
        required : false,
        type : Array
      },
      canModifyQuantity : {
        required : false,
        type : Boolean,
        default : true
      },
      canModifyStructure : {
        required : false,
        type : Boolean,
        default : true
      },
      actionUrl : {
        required : false,
        type : String
      },
      currency : {
        required : true,
        type : String
      }
    },
    mounted() {
      if(this.setStructure == ""){
        this.structure = this.trans('sample_order_structure_empty_text')
      }else{
        this.structure = this.setStructure;
      }
      this.updateSelectedStructure();
    },
    methods : {
      updateSelectedStructure(){
        let self = this;
        let selectedStructureObjects = self.structures.filter(function(item){return item.name == self.structure});
        if(selectedStructureObjects.length>0){
          self.selectedStructureObject = selectedStructureObjects[0];
        }
        else{
          self.selectedStructureObject = {
            car_info_text:'',
            image:'',
            name:'',
          };
        }
      },
      structureChanged() {
        this.updateSelectedStructure()
        this.changeData('update', 'structure')
      },
      getButtonClass(buttonClass) {
        let classes = 'fa color-order-button ' + buttonClass;
        if ( !this.changingData ) {
          classes += ' color-order-button-active';
        }
        return classes;
      },
      changeStructure(structure){
        this.selectedStructureObject= structure
        this.structure = this.selectedStructureObject.name;
        this.structureChanged()
      },
      changeData(action, event) {
        event;
        let self = this;
        if ( self.changingData ) {
          return;
        }
        self.changingData = true;
        axios
            .post(self.actionUrl, {
              action : action,
              item_id : self.color.id,
              extra : self.structure
            })
            .then(function(response) {
              self.changingData = false;
              if (response.data.success) {
                self.$emit('updateCartData', response.data.cartData);
              }
            });
      },
      increase() {
        this.changeData('increase', 'quantity');
      },
      decrease() {
        if ( this.quantity < 1 ) {
          return;
        }
        if ( this.quantity > 1 ) {
          this.changeData('decrease', 'quantity');
        } else {
          this.remove();
        }
      },
      remove() {
        this.changeData('delete', 'quantity');
      },
      trans(key){
        return translate(key);
      },
      myPpriceFormat(number){
        return priceFormat(number,window.sampleOrderShowPriceDecimals);
      }
    },
    computed : {
      getUnitPriceWithVat: function(){
        let vat = typeof window.sampleOrderVat != 'undefined' ? window.sampleOrderVat : 0;
        let itemVat = this.unitPrice / 100 * vat;
        itemVat = Math.round((itemVat + Number.EPSILON) * 100) / 100;
        return this.unitPrice+itemVat;
      },
      getSubtotal : function() {
        return this.quantity * this.getUnitPriceWithVat;
      },
      enableStructure: function(){
        return typeof window.useStructure != 'undefined' && window.useStructure == 1 ? true : false;
      }
    },
  }
</script>
<style lang="less">
  .colorsample-cartitem-details{
    padding-left:21px !important;
  }
  .colorsample-cartitem-functions{
    padding-right:50px !important;
  }
  .color-order-structure-container {
    display:flex;
    justify-content: end;
    width:100%;
    max-width:220px;
    height:44px;
    position: relative;
    margin-top:25px;

    .color-order-structure-select-label {
      position:absolute;
      font-family: FranklinGothicBookITC;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      color: #BCBCBC;
      top:-25px;
      left:0;
    }
    .color-order-structure-image-border{
      border: 1px solid #C4C4C4;
      width:35%;
      height:44px;
      border-right: 0px;
      .color-order-structure-image {
        width:100%;
        height:44px;
        background-size:cover;
        opacity:0.4;
      }
    }
    .color-order-structure-select {
      width:65%;
      background:white;
      font-family: 'FranklinGothicBookITC';
      padding-top:0;
      position: relative;
      display: block;
      .dropdown-toggle-dropdown-order {
        color: #000000;
        background-color: #ffffff;
        border-color: #c6c1b6 !important;
        position: relative;
        display: inline-block;
        font-weight: unset;
        text-align: left;
        white-space: nowrap;
        vertical-align: unset;
        font-size: 18px;
        font-family: "FranklinGothicBookITC";
        text-transform: none;
        line-height: 44px;
        height: 44px;
        width: 100%;
        padding: 0 38px 0 12px !important;
        border-radius: 0;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transition: color 300ms ease-in-out, background-color 300ms ease-in-out;
        &:after{
          position: absolute;
          content: '\F35D';
          font-family: 'Material Design Icons';
          width: 38px;
          height: 100%;
          border: none;
          vertical-align: unset;
          margin: unset;
          right: 0;
          font-size: 26px;
          text-align: center;
        }
        &:hover{
          color: #000000;
          background-color: darken(#ffffff, 10%);
        }
      }
      .dropdown-menu {
        max-height: 120px;
        overflow-x: auto;
        margin: -1px 0 0;
        padding: 0;
        min-width: 100%;
        border: 1px solid #c6c1b6;max-height: 120px;
        overflow-x: auto;
        margin: -1px 0 0;
        padding: 0;
        width: 100%;
        right: 0px !important;
        border: 1px solid #c6c1b6;
        left: unset !important
      }
      .dropdown-item {
        color: #000000;
        font-size: 18px;
        font-family: "FranklinGothicBookITC";
        line-height: 42px;
        padding: 0 12px;
        -webkit-appearance: none;
        cursor: pointer;
        transition: background-color 300ms ease-in-out;
        &:hover{
          color: #000000;
          background-color: #f7f5f4;
          border-color: #c6c1b6;
        }
      }
    }
  }
  .color-order-structure-details {
    font-family: FranklinGothicBookITC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    height:63px;
    text-align: right;
    color: #A5A5A5;
  }
  .color-order-subtotal {
    font-size:20px;
  }
  .color-order-row {
    font-family: "FranklinGothicBookITC";
    display:flex;
    color:black;
    font-size: 16px;
    padding-bottom:5px;
    justify-content: end;
    margin-bottom:5px;
  }
  .color-order-row-label{
    font-family: "FranklinGothicBookITC";
    color:#5D5D5D;
    font-size:12px;
    align-self:flex-end;
  }
  .color-order-row-value{
    font-family: "FranklinGothicDemiITC";
    color:#000000;
    font-size:20px;
    line-height:1;
  }
  .color-order-row-last-row {
    /*border-top: 1px solid rgba(0, 0, 0, 0.5);*/
    border-top:none;
  }
  .color-order-button-wrapper{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
  }
  .color-order-button:first-child {
    margin-right:5px;
  }
  .color-order-button:last-child {
    margin-left:5px;
  }
  .color-order-button {
    border:1px solid #C4C4C4;
    border-radius:50%;
    color:#C4C4C4;
    width: 20px;
    height: 20px;
    display: flex!important;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
  }
  .color-code-buttons-container {
    margin-top:10px;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
  }
  .color-code-buttons-container svg{
        cursor: pointer;
  }
  .color-code-buttons-container svg:hover{
        fill: #DF0A25;
  }
  .color-order-button-active {
    cursor:pointer;
  }
  .color-order-button-active:hover {
    color:#DF0A25;
  }

  a.color-code-button:hover{
    text-decoration: none;
  }
  .color-code-button {
    font-size:22px;
    padding-right:10px;
    padding-bottom:5px;
    color:white;
  }
  .color-code-button{
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    align-items: center;
  }
  .color-code-button i{
    color:#ada99f;
  }
  .color-code-button:hover i{
    color:#DF0A25;
  }
  .color-code-title {
    width: 91px;
    font-family: FranklinGothicBookITC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #5d5d5d;
  }
  .color-code {
    font-family: "FranklinGothicDemiITC";
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0em;
    text-align: left;
    color:black;
  }
  .color-details {
    color:#5d5d5d;
    font-family: FranklinGothicBookITC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
  }
  .color-block {
    height: 200px;
    width: 100%;
    border-radius: 0;
    margin:0;
  }
  @media screen and (max-width: 599px) {
    .color-block {
      height: 50px;
      width: 100%;
      border-radius: 0;
      margin-bottom:15px;
    }
    .colorsample-cartitem-details{
      padding-left:10px !important;
    }
    .colorsample-cartitem-functions{
      margin-top:10px;
      padding-right:10px !important;
    }
  }
  .svg-icon{
    width: 30px;
    padding: 5px;
    fill: #ada99f;
  }
</style>